import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { LoginState } from "../../../../../../lib/config/types"

const getLocalStorageData = (key: string) => {
  if (typeof window !== "undefined") {
    const data = localStorage.getItem(key)
    return data ? (key === "user" ? JSON.parse(data) : data) : null
  }
  return null
}

const initialState: LoginState = {
  isAuthenticated: Boolean(getLocalStorageData("user")) && Boolean(getLocalStorageData("caocaoAccessToken")),
  user: getLocalStorageData("user"),
  caocaoAccessToken: getLocalStorageData("caocaoAccessToken"),
  permissions: {},
}

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    doLoginAction: (
      state,
      action: PayloadAction<{
        user: {
          id: number
          email: string
          username: string
          provider: string
          confirmed: boolean
          blocked: boolean
          createdAt: string
          updatedAt: string
        }
        permissions: { [key: string]: { [key: string]: { enabled: boolean; policy: string } } }
      }>,
    ) => {
      state.isAuthenticated = true
      state.user = action.payload.user
      state.permissions = action.payload.permissions
    },
    doLogoutAction: state => {
      state.isAuthenticated = false
      state.user = null
      state.caocaoAccessToken = null
      state.permissions = {}
    },
  },
})

export const { doLoginAction, doLogoutAction } = loginSlice.actions

export default loginSlice.reducer
